import _ from 'lodash'
import {
  Bar,
  ComposedChart,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { useTheme } from '@mui/material'
import { ChartContainer, Container, TotalContainer } from './styles'
import {
  TooltipGraph,
  ViewDataLoading,
  ViewDataError,
} from '../../../../../components'
import {
  formatToLocaleString,
  parseNumberToFixedTwo,
} from '../../../../../utils'
import { ICustomTooltip, SelectDefaultValue } from '../../../../../domain'

const CustomTooltip = ({ active, payload }: ICustomTooltip) => {
  if (active && payload && payload.length) {
    return <TooltipGraph>Qtd de sociedades: {payload[0].value}</TooltipGraph>
  }
  return null
}

interface AverageResponseTimePageOneProps {
  data: any
  averageTotalResponse: number
  chartOrder: SelectDefaultValue
  mobile: boolean
  loading: boolean
}
const AverageResponseTimePageOne = ({
  data,
  chartOrder,
  averageTotalResponse,
  mobile,
  loading,
}: AverageResponseTimePageOneProps) => {
  const theme = useTheme()
  return (
    <>
      {loading && <ViewDataLoading />}

      {!loading &&
        (!data ||
          data.length === 0 ||
          parseFloat(parseNumberToFixedTwo(averageTotalResponse)) === 0) && (
          <ViewDataError />
        )}

      {parseFloat(parseNumberToFixedTwo(averageTotalResponse)) !== 0 &&
        data &&
        data.length > 0 &&
        !loading && (
          <Container>
            <ChartContainer sx={{ overflow: 'hidden' }}>
              <ResponsiveContainer minWidth={200} minHeight={300}>
                <ComposedChart
                  layout="vertical"
                  data={_.orderBy(
                    data,
                    [chartOrder.value.by],
                    [chartOrder.value.type],
                  )}
                >
                  <XAxis
                    type="number"
                    hide={true}
                    domain={[0, (dataMax: number) => dataMax * 1.2]}
                  />
                  <YAxis
                    dataKey="range"
                    type="category"
                    width={100}
                    tickLine={false}
                  />
                  <Bar
                    isAnimationActive={false}
                    dataKey="value"
                    barSize={40}
                    fill={theme.palette.primary.light}
                  >
                    <LabelList dataKey="value" position="right" fill="#000" />
                  </Bar>
                  {!mobile && <Tooltip content={<CustomTooltip />} />}
                </ComposedChart>
              </ResponsiveContainer>
            </ChartContainer>

            <TotalContainer>
              <h3>{`${
                formatToLocaleString(
                  parseNumberToFixedTwo(averageTotalResponse),
                ) ?? 0
              } milissegundos`}</h3>
              <p>TEMPO DE RESPOSTA MÉDIO DA API</p>
            </TotalContainer>
          </Container>
        )}
    </>
  )
}

export default AverageResponseTimePageOne
